import createWithBsPrefix from './createWithBsPrefix';
import divWithClassName from './divWithClassName';
var DivStyledAsH4 = divWithClassName('h4');
export default createWithBsPrefix('modal-title', {
  Component: DivStyledAsH4
});